'use strict';

var base = require('./base');
var detail = require('base/product/detail');

/**
 * Scroll to active accordion header with class scollTo
 */
function scrollToActiveAccordion() {
    if ($('.scrollTo').length > 0) {
        $('html, body').animate({
            scrollTop: $('.scrollTo').offset().top
        }, 2000);
    }
}

var exportDetail = $.extend({}, detail, {
    carouselInit: base.carouselInit,
    videoInModalInit: base.videoInModalInit,
    addToCart: base.addToCart,
    scrollToActiveAccordion: scrollToActiveAccordion,

    updateAddToCart: function () {
        $('body').on('product:updateAddToCart', function (e, response) {
            // update local add to cart (for sets)
            $('button.add-to-cart', response.$productContainer).attr('disabled',
                (!response.product.readyToOrder || !response.product.available || !response.product.sellable));

            var enable = $('.product-availability').toArray().every(function (item) {
                return $(item).data('available') && $(item).data('ready-to-order') && $(item).data('sellable');
            });
            $('button.add-to-cart-global').attr('disabled', !enable);
        });
    },
    updateAvailability: function () {
        $('body').on('product:updateAvailability', function (e, response) {
            $('div.availability', response.$productContainer)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available)
                .data('sellable', response.product.sellable);

            $('.availability-msg', response.$productContainer)
                .empty().html(response.message);

            if ($('.global-availability').length) {
                var allAvailable = $('.product-availability').toArray()
                    .every(function (item) { return $(item).data('available'); });

                var allReady = $('.product-availability').toArray()
                    .every(function (item) { return $(item).data('ready-to-order'); });

                var allSellable = $('.product-availability').toArray()
                    .every(function (item) { return $(item).data('sellable'); });

                $('.global-availability')
                    .data('ready-to-order', allReady)
                    .data('available', allAvailable)
                    .data('sellable', allSellable);

                $('.global-availability .availability-msg').empty()
                    .html(allReady ? response.message : response.resources.info_selectforstock);
            }
        });
    },
    accessibleZoomInit: function () {
        var targetImg = '.primary-images-container.d-th-block .product-carousel';
        var zoomFeatureImg = '.zoom-feature-img';
        var goToIndex;

        /**  Make the primary image reachable via tab key */
        $('.primary-images-container.d-th-block .product-carousel').attr({
            tabindex: 0,
            role: 'button'
        });

        /** Highlight the active thumbnail to match the enlarged view */
        function highlightActiveThumb() {
            $('.enlarged-img-thumbnail').removeClass('active-zoom-thumbnail');
            $('.enlarged-img-thumbnail[data-step="' + goToIndex + '"]').addClass('active-zoom-thumbnail');
        }

        /** Set the tabindex for the carousel's active slide */
        function setTabIndex() {
            $(zoomFeatureImg).find('.slick-slide').removeAttr('tabindex', 0);
            $(zoomFeatureImg).find('.slick-current').attr('tabindex', 0);
        }

        $(zoomFeatureImg).on('afterChange', function () {
            goToIndex = $(zoomFeatureImg).find('.slick-current').attr('data-slick-index') || 0;
            setTabIndex();
            highlightActiveThumb(goToIndex);
        });

        $('body').on('click', targetImg, function () {
            $('.product-zoom-modal').modal();
        }).on('keyup', targetImg, function (event) {
            if (event.code === 'Enter') $('.product-zoom-modal').modal();
        }).on('shown.bs.modal', '.product-zoom-modal', function () {
            goToIndex = $(targetImg).find('.slick-current').attr('data-slick-index');

            // INITIALIZE ENLARGED IMAGE CAROUSEL AFTER BOOTSTRAP MODAL INIT
            if ($(zoomFeatureImg).hasClass('slick-initialized')) {
                $(zoomFeatureImg).slick('slickGoTo', goToIndex);
            } else {
                $('.zoom-feature-img').slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                    accessibility: false,
                    initialSlide: goToIndex
                });
            }

            highlightActiveThumb(goToIndex);
            setTabIndex(zoomFeatureImg);

            $('.enlarged-img-thumbnail').on('click', function () {
                goToIndex = $(this).attr('data-step');
                $('.zoom-feature-img').slick('slickGoTo', goToIndex);
                highlightActiveThumb(goToIndex);
            }).on('keyup', function (event) {
                if (event.code === 'Enter') {
                    goToIndex = $(this).attr('data-step');
                    $('.zoom-feature-img').slick('slickGoTo', goToIndex);
                    highlightActiveThumb(goToIndex);
                }
            });
        });
    }
});

module.exports = exportDetail;
